export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Announcement',
        route: 'announcement',
        icon: 'HomeIcon'
      },
      {
        title: 'Second Page',
        route: 'second-page',
        icon: 'FileIcon'
      }
    ]
  }
]
